import { Model, model, prop } from "mobx-keystone";

@model("collab/Terms")
class Terms extends Model({
  id: prop<identifier>(),
  name: prop<string>(),
}) {}

export default Terms;
